import { colors, family } from './globalVariables';
import GlobalStyle from './GlobalStyle.styles';

export const theme = {
  colors,
  family
};

export default GlobalStyle;
